import { render, staticRenderFns } from "./SendReminderForms.vue?vue&type=template&id=514dcd4e&"
import script from "./SendReminderForms.vue?vue&type=script&lang=js&"
export * from "./SendReminderForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports